<template>
	<div>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {
			};
		},
		created() {
			localStorage.removeItem('sso-key');
			this.HTTP.get("/sso/login/loginOut").then(res=>{
			}).finally(()=>{
				this.$router.push('/login');
			})
		},
		methods: {
		},
	};
</script>
